<template>
  <vue-markdown v-if="pkg.version.readme" class="beast-markdown" v-text="pkg.version.readme"/>
  <div v-else>
    {{pkg.description}}
  </div>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  components: {
    VueMarkdown
  },
  props: {
    pkg: Object
  }
};
</script>
